import type { FlagRecord } from "@/hooks/useFeatureFlags/flags";

export const isFlexEmulatorAvailable = (): boolean => import.meta.env.DEV;

/** Flex call UI (incoming-call modal + wrap-up sheet): flag on, or a DEV-only emulator session. */
export const isFlexCallIntegrationEnabled = (flags: FlagRecord, emulatorSession: boolean): boolean =>
  !!flags["backoffice-twilio-call-event-integration"] || (emulatorSession && isFlexEmulatorAvailable());

/** Flex transcript summaries: flag on, or a DEV-only emulator session. */
export const isFlexTranscriptSummaryEnabled = (flags: FlagRecord, emulatorSession: boolean): boolean =>
  !!flags["flex-call-transcript-summary"] || (emulatorSession && isFlexEmulatorAvailable());
